import billingStatus from '@/views/billing/billing-datatable/billing-status.json';
import EnumObject from '../../enum-object.entity';

export default class ContractItemBillingReport {
  id: string;

  code: string;

  status: EnumObject;

  versionDate: string;

  customerName: string;

  customerDocument: string;

  customerTradingName: string;

  externalId: number;

  resultCenter: string;

  beneficiary: string;

  itemNumber: number;

  itemDescription: string;

  itemFrequency: EnumObject

  ruleName: string;

  ruleParameters: string;

  alreadyBilling: boolean;

  lastInvoice: string;

  lastInvoiceCompetence: string;

  lastInvoiceStatus: string;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.code = obj.code || '';
    this.status = EnumObject.of(obj.status) || {};
    this.versionDate = obj.versionDate || '';
    this.customerName = obj.customerName || '';
    this.customerDocument = obj.customerDocument || '';
    this.customerTradingName = obj.customerTradingName || '';
    this.externalId = obj.externalId || 0;
    this.resultCenter = obj.resultCenter || '';
    this.beneficiary = obj.beneficiary || '';
    this.itemNumber = obj.itemNumber || null;
    this.itemDescription = obj.itemDescription || '';
    this.itemFrequency = obj.itemFrequency || '';
    this.ruleName = obj.ruleName || '';
    this.ruleParameters = obj.ruleParameters || '';
    this.alreadyBilling = obj.alreadyBilling || false;
    this.lastInvoice = obj.lastInvoice || '';
    this.lastInvoiceCompetence = obj.lastInvoiceCompetence || '';
    this.lastInvoiceStatus = obj.lastInvoiceStatus || '';
  }

  public static of(obj: any): ContractItemBillingReport {
    return new ContractItemBillingReport(obj || {});
  }

  public static ofList(obj: any[]): ContractItemBillingReport[] {
    return obj.map(this.of);
  }

  get isInactive(): boolean {
    return this.status.value === 'INACTIVE'
  }

  get isCanceled(): boolean {
    return this.status.value === 'CANCELED'
  }

  get isAlreadyBilling(): string {
    return this.alreadyBilling ? 'Sim' : 'Não';
  }

  get billingStatusDescription(): string {
    const status = billingStatus.find((s) => s.value === this.lastInvoiceStatus);
    return status ? status.description : '';
  }
}
